import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { FraudDashboardGaugesResponse } from '@/types/fraudDashboard';

export function useFraudDashboardGauges() {
  return useQuery<FraudDashboardGaugesResponse>({
    queryKey: ['fraud-dashboard', 'gauges'],
    queryFn: async () => {
      const { data } = await api.get<FraudDashboardGaugesResponse>(
        '/fraud-dashboard/gauges',
      );
      return data;
    },
    staleTime: 60_000,
  });
}
